import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ButtonDemo from '../button'
import style from './style.module.scss'

export function Inside() {
    const { t } = useTranslation();
    const [active, setActive] = useState(0)

    const insideBlockInfo = t('inside.items', { returnObjects: true })

    return (
        <section className={`container section ${style["inside"]}`}>
            <div className={style["inside__left"]}>
                <div className={style["inside__left-title"]}>
                    <h3>{t('inside.label')}</h3>
                    <h1>
                        {t('inside.title.line1')} <br />
                        {t('inside.title.line2')} <br />
                        {t('inside.title.line3')}
                    </h1>
                </div>

                <div className={style['inside__btn--desktop']}>
                    <ButtonDemo size='large' directIcon>
                        {t('button.titleBook')}
                    </ButtonDemo>
                </div>
            </div>

            <div className={style["inside__right"]}>
                {insideBlockInfo.map((item, i) => (
                    <div
                        key={i}
                        className={`${style["inside__item"]} ${i === active ? style["inside__item--active"] : ''}`}
                        onClick={() => setActive(i)}
                    >
                        <span className={style["inside__item-number"]}>
                            {item.number}
                        </span>

                        <div className={style["inside__item-content"]}>
                            <h2>{item.title}</h2>
                            <p>{item.subtitle}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className={style['inside__btn--mobile']}>
                    <ButtonDemo size='large' directIcon>
                        {t('button.titleBook')}
                    </ButtonDemo>
                </div>
        </section>
    )
}